// Vendor imports
const Chance = require('chance')
const Immutable = require('immutable')
const { createSelector } = require('reselect')
// Client lib imports
const businessEvents = require('client/lib/business-events')
// Client V2 common imports
const AppPromoCard = require('client-v2/common/components/cards/app-promo')
const tag = require('client-v2/common/utils/hyperscript')

const FIRST_APP_PROMO_CARD_INDEX = 4
const PAGE_SIZE = 15
const SPACING_BETWEEN_APP_PROMO_CARDS = PAGE_SIZE * 2 // Every other page

function getInterleaveIndexes(itemsCount) {
  const indexes = []
  for (let i = 0; i < itemsCount; i++) {
    const isIndexBetweenAppPromoCards = (
      (i - FIRST_APP_PROMO_CARD_INDEX) %
      SPACING_BETWEEN_APP_PROMO_CARDS
    )
    if (!isIndexBetweenAppPromoCards) {
      indexes.push(i)
    }
  }
  return indexes
}

function onAppPromoCardClick({ variant }) {
  businessEvents.trackSegment('app-promo-card-click', { variant })
  window.location.assign('/download')
}

function onAppPromoBadgeClick({ variant, badge }) {
  businessEvents.trackSegment('app-promo-card-badge-click', { variant, badge })
  // Navigation is handled by the <a href> default behavior
}

function onAppPromoCardView({ variant }) {
  businessEvents.trackSegment('app-promo-card-view', { variant })
}

function renderAppPromoCard({ id, variant }) {
  return (
    tag(AppPromoCard, {
      key: id,
      variant,
      onBadgeClick: onAppPromoBadgeClick,
      onCardClick: onAppPromoCardClick,
      onFullyVisible: onAppPromoCardView
    })
  )
}

module.exports = function (feedSelectors) {

  const seed = Math.random()
  let chance = new Chance(seed)

  function createAppPromoCardFeedItem(index) {
    return {
      id: `app-promo-card:${index}`,
      type: 'render',
      render: renderAppPromoCard,
      variant: chance.pickone(AppPromoCard.VARIANTS)
    }
  }

  const interleaveItemsWithAppPromoCards = createSelector(
    items => items,
    items => {
      // Reset the RNG to produce repeatable results
      chance = new Chance(seed)
      // Build a new list of items with promo cards peppered in
      const acc = []
      const interleaveIndexes = getInterleaveIndexes(items.size)
      let nextInterleaveIndex = interleaveIndexes.shift()
      items.forEach((item, index) => {
        if (index === nextInterleaveIndex) {
          acc.push(createAppPromoCardFeedItem(acc.length))
          nextInterleaveIndex = interleaveIndexes.shift()
        }
        acc.push(item)
      })
      return Immutable.List(acc)
    }
  )

  const isAppPromoCardInterleaveEnabled = createSelector(
    state => state.env.browser,
    state => state.user.hasRollout('app_promo_cards'),
    (browser, hasRollout) => (
      hasRollout &&
      !browser.get('native') &&
      (browser.get('ios') || browser.get('android'))
    )
  )

  const getDenormalizedItems = createSelector(
    [
      isAppPromoCardInterleaveEnabled,
      feedSelectors.getDenormalizedItems
    ],
    (isInterleaveEnabled, items) => (
      isInterleaveEnabled
      ? interleaveItemsWithAppPromoCards(items)
      : items
    )
  )

  return {
    getDenormalizedItems,
    interleaveItemsWithAppPromoCards,
    isAppPromoCardInterleaveEnabled
  }
}
